import { IControlZoneNotification } from './control-zone-notification.model';

export enum EOverviewViewIcons {
  full = 'full',
  empty = 'empty',
  almostFull = 'almostFull',
  inUse = 'inUse',
}

export enum EOverViewPercentFullLimits {
  almostFull = 78,
  full = 100,
}

export enum EOverviewLocationType {
  hospital = 'hospital',
  building = 'building',
  floor = 'floor',
  room = 'room',
}

export enum EOverviewViewStatus {
  wasteBinFull = 'Waste Bin Full',
  rxInterceptBoxFull = 'Rx Intercept box full',
  hardwareError = 'Hardware Error',
  available = 'Available',
  approachingCapacity = 'Approaching Capacity',
  inUse = 'In Use',
}

export interface OverviewView {
  id: number;
  name: string;
  locationId: number;
  location: IOverciewLocation[];
  locationName: string;
  buildingName: string;
  buildingId: number;
  organizationName: string;
  collectionBins: ICollectionBins[];
  collectionBox: ICollectionBox;
  cartMode: number;
  inUse: boolean;
  locationTree: string;
  statusId: number;
  error?: IOverviewError;
  cartNotification?: IControlZoneNotification;
  windowsMachineName: string;
  assetTag: string;
}

export interface ICollectionBins {
  containerTypeName: string;
  serialNumber: number;
  capacity: number;
  wastedCount: number;
  percentFull: number;
}

export interface ICollectionBox {
  wastedCount: number;
  containerTypeName: string;
  capacity: number;
  percentFull: number;
}

export interface IOverviewStyleAndIconInfo {
  statusStyle: string;
  cardStyle: string;
  status: string;
  canStatus: string;
  dialogStyle: string;
  color: string;
}

export interface OverviewViewWithStyle extends OverviewView {
  styles: IOverviewStyleAndIconInfo;
  cardNumber: string;
}

export interface OverviewViewGroup {
  building: string;
  views: OverviewViewWithStyle[];
}

export interface IOverciewLocation {
  id: number;
  name: string;
  description: string;
  parentId: number;
  locationType: EOverviewLocationType;
}

export interface IOverviewError {
  description: string;
  detectedAt: Date;
  priority: string;
  attendedBy: string;
  startAttendedAt: Date;
  finishAttendedAt: Date;
}
